import styled from 'styled-components';
import { getColor } from 'core/utils';

export const Modal = styled.div`
	margin: 50px auto;
	max-width: 350px;
	width: 95%;
	padding: 10px;
	box-shadow: 0 0 30px 0 rgba(60, 77, 88, 0.1);
	border-radius: 4px;
	background-color: ${getColor('white')};

	@media (min-width: 768px) {
		max-width: 500px;
		padding: 48px 88px;
	}
`;
